import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CrmService } from "../../../servicios/crm.service";
import { MatSnackBar } from "@angular/material/snack-bar";

type Operacion = {
  cantidadEspacioMB: number;
  cantidadTiempoHoras: number;
  precioPorMB: number;
  precioPorHora: number;
  pagoRecibido: boolean;
  fechaOrden: Date;
  fechaEjecucion?: Date;
  recargoEquivalencia?: boolean;
};

@Component({
  selector: "app-nueva-operacion-cuotas-gestor-proyectos",
  templateUrl: "./nueva-operacion-cuotas-gestor-proyectos.component.html",
  styleUrls: ["./nueva-operacion-cuotas-gestor-proyectos.component.css"],
})
export class NuevaOperacionCuotasGestorProyectosComponent implements OnInit {
  formCuotas: FormGroup;
  totalOperacion: number = 0;
  constructor(
    private fb: FormBuilder,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<NuevaOperacionCuotasGestorProyectosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private crmservice: CrmService
  ) {
    this.formCuotas = this.fb.group({
      cantidadEspacioMB: [0, [Validators.required, Validators.min(0)]],
      precioPorMB: [0, [Validators.required, Validators.min(0)]],
      cantidadTiempoHoras: [0, [Validators.required, Validators.min(0)]],
      precioPorHora: [0, [Validators.required, Validators.min(0)]],
      pagoRecibido: [false],
    });

    // Suscribirse a los cambios del formulario para calcular el total
    this.formCuotas.valueChanges.subscribe(() => {
      this.calcularTotal();
    });
  }

  ngOnInit(): void {}

  calcularTotal(): void {
    const valores = this.formCuotas.value;
    const totalEspacio = valores.cantidadEspacioMB * valores.precioPorMB;
    const totalTiempo = valores.cantidadTiempoHoras * valores.precioPorHora;
    this.totalOperacion = totalEspacio + totalTiempo;
  }

  guardar(): void {
    if (this.formCuotas.valid) {
      const valores = this.formCuotas.value;

      const operacion: Operacion & { idDireccion?: string } = {
        cantidadEspacioMB: valores.cantidadEspacioMB,
        cantidadTiempoHoras: valores.cantidadTiempoHoras,
        precioPorMB: valores.precioPorMB,
        precioPorHora: valores.precioPorHora,
        pagoRecibido: valores.pagoRecibido,
        fechaOrden: new Date(),
        recargoEquivalencia: false,
      };

      if (this.data.idDireccion) {
        operacion.idDireccion = this.data.idDireccion;
      }

      this.crmservice
        .guardarOperacionGestorProyectos(operacion, this.data.cliente._id)
        .then((data) => {
          const { operacionesCuotasGestorProyectos, mensaje, resultado } = data;

          if (operacionesCuotasGestorProyectos?.length && resultado?.operacion?.facturaExpansionCreada) {
            const ultimaOperacion =
              operacionesCuotasGestorProyectos[operacionesCuotasGestorProyectos.length - 1];
            ultimaOperacion.facturaExpansionSerie = resultado.operacion.facturaExpansionSerie;
            ultimaOperacion.facturaExpansionNumero = resultado.operacion.facturaExpansionNumero;
            ultimaOperacion.facturaExpansionCreada = true;
          }

          this.toast(
            mensaje ||
              (valores.cantidadTiempoHoras > 0 && !valores.pagoRecibido
                ? "Operación creada correctamente. La factura SER se generará al marcar como cobrada."
                : this.construirMensajeCompleto(mensaje, resultado))
          );

          if (operacion.pagoRecibido) {
            operacion.fechaEjecucion = new Date();
          }
          this.data.cliente.operacionesCuotasGestorProyectos = operacionesCuotasGestorProyectos;
          this.dialogRef.close(this.data.cliente);
        })
        .catch((error) => {
          console.error(error);
          const cuerpo = error?.error;
          const operaciones = cuerpo?.operacionesCuotasGestorProyectos;
          if (operaciones) {
            this.data.cliente.operacionesCuotasGestorProyectos = operaciones;
            this.dialogRef.close(this.data.cliente);
          }
          this.toast(
            cuerpo?.message || cuerpo?.mensaje || "Error al guardar la operación"
          );
        });
    }
  }

  private toast(msg: string = "Desconocido"): void {
    this.snackBar.open(msg, "OK", { duration: 6000 });
  }

  private construirMensajeCompleto(mensaje: string | undefined, resultado: any): string {
    const partes: string[] = [];

    if (mensaje) {
      partes.push(mensaje);
    } else if (resultado?.facturacion?.mensaje) {
      partes.push(resultado.facturacion.mensaje);
    }

    const factura = resultado?.facturacion?.factura;
    if (factura?.generada && factura?.serie && factura?.numero) {
      const resumenFactura = `Factura ${factura.serie}-${factura.numero}${
        factura.importeTotal !== null && factura.importeTotal !== undefined
          ? ` (${Number(factura.importeTotal).toFixed(2)} €)`
          : ""
      }`;
      if (!partes.some((parte) => parte.includes(String(factura.numero)))) {
        partes.push(resumenFactura);
      }
    }

    if (resultado?.facturacion?.exitosa === false && resultado?.facturacion?.mensaje) {
      return partes.join(" ") || "Operación guardada. AVISO: no se pudo confirmar la factura.";
    }

    return partes.join(" ") || "Operación guardada correctamente";
  }

  private construirMensajeDesdeResultado(resultado: any): string | null {
    if (!resultado?.facturacion) return null;
    return resultado.facturacion.mensaje || null;
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
